import React from 'react';
import PopupUpdateAmount from "../PopupUpdateAmount";

export function UpdateAmountColumnFormatter(cellContent, intl, dispatch) {

  return (
    <PopupUpdateAmount
      cellContent={cellContent}
      intl={intl}
      dispatch={dispatch}
    />
  );
}
